import type { AccountResponse } from '@/account/index';

export function searchFormsRecyclingValidation(
  account: AccountResponse | null,
  closeForm?: () => void
) {
  const userInRecycling = account?.account.user_info.user_in_recycling;
  const hasRecyclingReports =
    !!account?.account.subscription_info.recycling_reports_remaining;

  if (userInRecycling && !hasRecyclingReports) {
    window.dispatchEvent(new CustomEvent('openRecyclingModal'));
    if (closeForm) {
      closeForm();
    }
    return false;
  }
  return true;
}
